import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {withTranslation} from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";
import {ANALYTICS_CHANNEL} from '../../channels/channels';
import {clearOauthReturn, destinationOf, errorDestinationOf, peekOauthReturn} from '../../onboarding/oauthReturn';


import {withRouterParams} from "../../../utils/withRouterParams";

let oauthExchangeInFlight = false;

const CLASSIC_PATH = '/agency/conections';

/**
 * La vuelta del OAuth de Google Analytics.
 *
 * Respeta la nota de `oauthReturn` igual que `ConnectAdwordsAccount`: si la conexión se pidió desde
 * el wizard «Nueva línea» (paso 3), vuelve ahí con `?just_connected=ANALYTICS` en vez de dejar al
 * usuario en Conexiones del clásico (recorrido de fede, 01/10, punto 11). Sin nota, el camino de
 * siempre: Conexiones, ahora con un toast en vez del `alert()`.
 */
class ConnectGA4Account extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        // La nota se lee UNA vez, al montar, y el destino viaja con el resto: leída al final del POST
        // podía estar borrada (ver el comentario largo de `ConnectAdwordsAccount`).
        const tunnelReturn = peekOauthReturn();
        const inTunnel = Boolean(tunnelReturn);
        const irA = destino => {
            this.props.history.push(destino);
            clearOauthReturn();
        };
        // En el clásico el destino no cambia: Conexiones, sin parámetros.
        const okDestination = inTunnel
            ? destinationOf(tunnelReturn, `${CLASSIC_PATH}?just_connected=${ANALYTICS_CHANNEL}`)
            : CLASSIC_PATH;

        let code = new URLQueryStringParser().getUrlParams('code');
        if (!code) {
            irA(errorDestinationOf(tunnelReturn, CLASSIC_PATH, ANALYTICS_CHANNEL));
            return;
        }
        try {
            const url = new URL(window.location.href);
            ['code', 'scope', 'authuser', 'prompt', 'state', 'hd'].forEach((p) => url.searchParams.delete(p));
            window.history.replaceState({}, '', url.pathname + (url.search || ''));
        } catch (e) { /* noop */ }
        if (oauthExchangeInFlight) {
            // Sin consumir la nota: esta rama existe porque el componente se monta dos veces.
            this.props.history.push(tunnelReturn || CLASSIC_PATH);
            return;
        }
        const guardKey = 'connecting_ga4_oauth_code';
        if (sessionStorage.getItem(guardKey) === code) {
            this.props.history.push(tunnelReturn || CLASSIC_PATH);
            return;
        }
        oauthExchangeInFlight = true;
        sessionStorage.setItem(guardKey, code);
        let credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        const fallo = () => {
            oauthExchangeInFlight = false;
            sessionStorage.removeItem(guardKey);
            // En el wizard el aviso lo pinta el paso, con su propio texto: nada encima.
            if (inTunnel) {
                irA(errorDestinationOf(tunnelReturn, CLASSIC_PATH, ANALYTICS_CHANNEL));
                return;
            }
            // Texto propio, nunca el del backend: llega en inglés o en voseo (card 5qObKTLi).
            toast.error(this.props.t('connections.oauth.error_generic'));
            this.props.history.push(CLASSIC_PATH);
        };
        new APIClient(API_URL + 'get_access_tokens/ga4/').call('POST', {'code': code, 'credential_label': credential_label}).then((data) => {
            if (data && data.status === 'OK') {
                irA(okDestination);
                if (!inTunnel) toast.success(this.props.t('connections.ga4.connected_ok'));
            } else {
                fallo();
            }
        }).catch(fallo)
    }

    render() {
        return <Loading message={this.props.t('connections.oauth.connecting')}/>
    }
}

export default withTranslation()(withRouterParams(ConnectGA4Account));
